import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreTagsUnlinkPostAsyncSlice } from './post';

export const coreTagsUnlinkReducers = combineReducers({
	post: coreTagsUnlinkPostAsyncSlice.asyncReducers
});

export const coreTagsUnlinkWatchers = combineAllWatchers([ coreTagsUnlinkPostAsyncSlice.asyncWatchers ]);
